export enum LoginViewFrameState {
  Initial = 0,
  Loading = 1,
  Redirect = 2,
  Error = 3
}
